import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule} from '@angular/material/menu';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { AuthenticationService } from './shared/packages/auth/services/authentication.service';
import { JwtInterceptor } from './shared/packages/auth/helpers/jwt.interceptor';
import { ErrorInterceptor } from './shared/packages/auth/helpers/error.interceptor';
import { ToastrModule } from 'ngx-toastr';

/*import {EchoConfig, NgxLaravelEchoModule} from 'ngx-laravel-echo';

export const echoConfig: EchoConfig = {
  userModel: 'users',
  notificationNamespace: 'App\\Notifications',
  options: {
      broadcaster: 'pusher',
      key: '124',
      wsHost: 'api.test',
      authEndpoint: 'http://api.test/broadcasting/auth',
      host: 'api.test',
      wsPort: 6001,
      disableStats: true,
      namespace: ''
  }
};*/

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    LoadingBarRouterModule,
    //NgxLaravelEchoModule.forRoot(echoConfig),
    ToastrModule.forRoot()
  ],
  providers: [
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
